import React from 'react';
import PropTypes from 'prop-types';
import DateTime from './DateTime';
import daySkipped from '../../utils/daySkipped';

const DateTimeInfo = ({ ...props }) => {
  const { config } = props;
  return daySkipped(config) ? null : (
    <span className="DateTimeInfo">
      Date:&nbsp;
      <DateTime {...props} />
    </span>
  );
};

DateTimeInfo.propTypes = {
  date: PropTypes.string,
  config: PropTypes.object.isRequired
};

export default DateTimeInfo;
